import { type ReactNode } from 'react'
import {
  SideSheetMain,
  SideSheetHostView,
  type SideSheetElevation,
} from '@/components/SideSheet'
import { useScrollOffsets } from '@/hooks/element-hooks'
import styles from './WorkspaceOpportunities.module.css'
import {
  StickyViewHeader,
  StickyViewHeaderSpacer,
} from '@/components/StickyViewHeader'
import { ViewHeading } from '@/components/ViewHeading'
import { StaffingAnnouncementBanner } from '@/features/opportunities/components/StaffingAnnouncementBanner'
import { ResultCounts } from '@/components/ResultCounts'
import { ContentLayout, ContentMain } from '@/components/ContentLayout'

export interface WorkspaceOpportunitiesMainViewProps {
  tabBars: ReactNode
  sheetVisible: boolean
  sheetElevation: SideSheetElevation
  onRequestHideSheet: () => unknown
  resultCount: number
  list: ReactNode
  detailsSheet: ReactNode
  corporateMode: boolean
}

export function WorkspaceOpportunitiesMainView({
  tabBars,
  sheetVisible,
  sheetElevation,
  onRequestHideSheet,
  resultCount,
  list,
  detailsSheet,
  corporateMode,
}: WorkspaceOpportunitiesMainViewProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <>
      <SideSheetHostView
        sheetVisible={sheetVisible}
        elevation={sheetElevation}
        onRequestHide={onRequestHideSheet}
      >
        <SideSheetMain>
          <div className={styles.root} ref={scrollRef}>
            <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBars}>
              <ViewHeading
                primaryText="Opportunities"
                isDropdown={false}
                secondaryText="All Workspaces"
              />
              <StickyViewHeaderSpacer />
            </StickyViewHeader>
            <ContentLayout accountForTabBar={Boolean(tabBars)}>
              <ContentMain>
                <div className={styles.banner}>
                  <StaffingAnnouncementBanner corporateMode={corporateMode} />
                </div>
                <div className={styles.resultsCount}>
                  <ResultCounts showing={resultCount} total={null} />
                </div>
                {list}
              </ContentMain>
            </ContentLayout>
          </div>
        </SideSheetMain>
        {detailsSheet}
      </SideSheetHostView>
    </>
  )
}
